<template>
    <section class="mvt-pagination grid xs-grid-cols-1">
        <div class="f4 text-center" v-if="showCount && totalCount > 0">
            <b class="text-bold">{{ paginationDetails.start }} - {{ paginationDetails.end }} of {{ paginationDetails.totalCount }}</b> <span v-if="paginationDetails.label" v-html="paginationDetails.label"></span>
        </div>
        <div class="mvt-pagination__list" v-if="pageCount && pageCount > 0">
            <a class="mvt-pagination__list-item mvt-pagination__list-item--prev" :href="prevLink ? prevLink : '#'" :disabled="!prevLink" aria-label="Previous Page"></a>
            <template v-if="showFirstPage">
                <a class="mvt-pagination__list-item" :href="firstLink ? firstLink : '#'">1</a>
                <span>...</span>
            </template>
            <template v-for="item in dynamicList" :key="item.pageNumber">
                <span v-if="item.isGroup">...</span>
                <a :href="`${baseUrl}${item.pageNumber>1 ? `p-${item.pageNumber}/` : ''}`" :class="['mvt-pagination__list-item', {'mvt-pagination__list-item--active': activePageNumber === item.pageNumber}]">{{ item.pageNumber }}</a>
            </template>
            <template v-if="showLastPage">
                <span v-if="dynamicList[dynamicList.length - 1].pageNumber !== pageCount - 1">...</span>
                <a class="mvt-pagination__list-item" :href="lastLink ? lastLink : '#'">{{ pageCount }}</a>
            </template>
            <a class="mvt-pagination__list-item mvt-pagination__list-item--next" :href="nextLink ? nextLink : '#'" :disabled="!nextLink" role="button" aria-label="Next Page"></a>
        </div>
    </section>
</template>
<script src="./mvt-pagination.js">
</script>
<style lang="scss">
@use "./mvt-pagination.scss" as *;
</style>
